if (!customElements.get('campaign-story-carousel')) {
  customElements.define('campaign-story-carousel', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-campaign-rail]');
      this.thumb = this.querySelector('[data-campaign-progress]');
      if (!this.rail || !this.thumb) return;

      this.drag = null;
      this.suppressDragClick = false;

      this.update = () => {
        const maxScroll = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
        const offset = Math.min(maxScroll, Math.max(0, this.rail.scrollLeft));
        const fill = this.rail.scrollWidth > 0
          ? Math.min(1, (this.rail.clientWidth + offset) / this.rail.scrollWidth)
          : 1;
        this.thumb.style.transform = `scaleX(${fill})`;
        this.thumb.parentElement.hidden = maxScroll <= 1;
      };

      this.rail.addEventListener('scroll', this.update, { passive: true });
      this.onPointerDown = (event) => {
        if (event.pointerType === 'touch' || event.button !== 0 || !event.isPrimary) return;
        if (event.target instanceof Element && event.target.closest('button, input, select, textarea, [contenteditable]')) return;

        this.drag = {
          pointerId: event.pointerId,
          startX: event.clientX,
          startScroll: this.rail.scrollLeft,
          moved: false,
        };
      };

      this.onPointerMove = (event) => {
        const drag = this.drag;
        if (!drag || drag.pointerId !== event.pointerId) return;

        const distance = drag.startX - event.clientX;
        if (!drag.moved && Math.abs(distance) < 6) return;

        if (!drag.moved) {
          drag.moved = true;
          this.rail.setAttribute('data-dragging', '');
        }

        event.preventDefault();
        this.rail.scrollLeft = drag.startScroll + distance;
      };

      this.onPointerEnd = (event) => {
        const drag = this.drag;
        if (!drag || drag.pointerId !== event.pointerId) return;

        this.drag = null;
        if (!drag.moved) return;

        this.rail.removeAttribute('data-dragging');
        this.suppressDragClick = true;
        clearTimeout(this.dragClickTimer);
        this.dragClickTimer = setTimeout(() => { this.suppressDragClick = false; }, 0);
      };

      this.onClick = (event) => {
        if (!this.suppressDragClick) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.suppressDragClick = false;
        clearTimeout(this.dragClickTimer);
      };

      this.onDragStart = (event) => event.preventDefault();
      this.rail.addEventListener('pointerdown', this.onPointerDown);
      window.addEventListener('pointermove', this.onPointerMove);
      window.addEventListener('pointerup', this.onPointerEnd);
      window.addEventListener('pointercancel', this.onPointerEnd);
      this.rail.addEventListener('click', this.onClick, true);
      this.rail.addEventListener('dragstart', this.onDragStart);
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.rail);
      this.update();
    }

    disconnectedCallback() {
      this.rail?.removeEventListener('scroll', this.update);
      this.rail?.removeEventListener('pointerdown', this.onPointerDown);
      window.removeEventListener('pointermove', this.onPointerMove);
      window.removeEventListener('pointerup', this.onPointerEnd);
      window.removeEventListener('pointercancel', this.onPointerEnd);
      this.rail?.removeEventListener('click', this.onClick, true);
      this.rail?.removeEventListener('dragstart', this.onDragStart);
      this.rail?.removeAttribute('data-dragging');
      clearTimeout(this.dragClickTimer);
      this.drag = null;
      this.observer?.disconnect();
    }
  });
}
